/**
 * @tennis-matches/core/ko
 * Typen und Konstanten für K.O.-Phase (wiederverwendbar für Schleifchen, Clubmeisterschaft, etc.)
 */

/** Placeholder-Typen für Match-Seiten (ohne konkrete Spieler bis Ergebnis bekannt) */
export const KO_PLACEHOLDER = {
  /** Team nach Ranglisten-Platz (n = 1..8): Team 1 = Platz 1&2, Team 2 = Platz 3&4, … */
  RANK: "ko-rank",
  /** Sieger VFn (Top 8, für Halbfinale) */
  WINNER_VF: "ko-winner-vf",
  /** Sieger R1n (Top 6, erste K.O.-Runde → geht ins Halbfinale; Anzeige: Sieger HF) */
  WINNER_R1: "ko-winner-r1",
  /** Sieger HFn (für Finale) */
  WINNER_HF: "ko-winner",
  /** Verlierer HFn (für Platz 3) */
  LOSER_HF: "ko-loser",
  /** Verlierer R1n (Top 6, für Spiel um Platz 5 & 6) */
  LOSER_R1: "ko-loser-r1",
};

/** Unterstützte K.O.-Teilnehmerzahlen (Teams bei Doppel) */
export const KO_TEILNEHMER_VALID = [2, 4, 6, 8];
